import { Form, Input } from "antd";
import { Card } from "react-bootstrap";

import Button from "antd-button-color";

import "./style.css";

const PasswordContainer = () => {
  return (
    <>
      <Card>
        <Card.Header className="bg-transparent">
          <Card.Title className="p-t-8 p-b-2">Ubah Password</Card.Title>
        </Card.Header>
        <Card.Body>
          <Form layout="vertical">
            <Form.Item label="Password Saat Ini" className="mb-3">
              <Input.Password placeholder="Password Saat Ini" />
            </Form.Item>

            <Form.Item label="Password Yang Baru" className="mb-3">
              <Input.Password placeholder="Password Yang Baru" />
            </Form.Item>

            <Form.Item label="Konfirmasi Password" className="mb-3">
              <Input.Password placeholder="Konfirmasi Password" />
            </Form.Item>

            <Form.Item className="mb-0">
              <Button type="dark">Simpan</Button>
            </Form.Item>
          </Form>
        </Card.Body>
      </Card>
    </>
  );
};

export default PasswordContainer;
